import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AppDataSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: ADS_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: {
        policyUrl: serverRes?.data?.appInfo?.policyUrl || '',
        cguUrl: serverRes?.data?.appInfo?.cguUrl || '',
        faqUrl: serverRes?.data?.appInfo?.faqUrl || '',
        whatsappLink: serverRes?.data?.appInfo?.whatsappLink || '',
        telegramLink: serverRes?.data?.appInfo?.telegramLink || '',
        instagramLink: serverRes?.data?.appInfo?.instagramLink || '',
        facebookLink: serverRes?.data?.appInfo?.facebookLink || '',
        tiktokLink: serverRes?.data?.appInfo?.tiktokLink || '',
        websiteLink: serverRes?.data?.appInfo?.websiteLink || ''
      }
    };
  }

  serialize() {}
}

export const serializer = new AppDataSerializer();
